import React from "react";
import { WhatsOnHeroProps } from "./types";
import { useLazyLoad } from "../../helpers/hooks";
const Comp = React.lazy(() => import("./"));

export default (props: WhatsOnHeroProps) => useLazyLoad(<Comp {...props} />);
